var ArticleView,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

ArticleView = (function() {
  function ArticleView(article_id, options) {
    this.unpublish = __bind(this.unpublish, this);
    this.publish = __bind(this.publish, this);
    this.unfix_title = __bind(this.unfix_title, this);
    this.fix_title = __bind(this.fix_title, this);
    this.hide_title = __bind(this.hide_title, this);
    this.show_title = __bind(this.show_title, this);
    this.remove_cover = __bind(this.remove_cover, this);
    this.set_cover = __bind(this.set_cover, this);
    this.add_video = __bind(this.add_video, this);
    this.add_image = __bind(this.add_image, this);
    this.save_content = __bind(this.save_content, this);
    this.load = __bind(this.load, this);
    Observable(this, 'article', null);
    this.load(article_id);
  }

  ArticleView.prototype.load = function(article_id) {
    return Article.find(article_id, {}, (function(_this) {
      return function(data) {
        _this.article(Article(data));
        if (data.asset_id > 0) {
          Asset.find(data.asset_id, {}, function(data) {
            return _this.article().asset(Asset(data));
          });
        }
        window.title_editor = new MediumEditor('#post_title', {
          disableToolbar: true,
          disableReturn: true,
          placeholder: 'Title',
          firstHeader: 'h1'
        });
        window.pretext_editor = new MediumEditor('#post_pretext', {
          disableToolbar: true,
          disableReturn: true,
          placeholder: 'Pretext'
        });
        window.editor = new MediumEditor('#post_content', {
          buttons: ['bold', 'italic', 'underline', 'anchor', 'header1', 'header2', 'quote', 'unorderedlist']
        });
        $('#post_content').mediumInsert({
          editor: window.editor,
          images: true
        });
        $('#post_title').bind('input', function() {
          return _this.save_content('title');
        });
        $('#post_content').bind('input', function() {
          return _this.save_content();
        });
        $('#post_pretext').bind('input', function() {
          return _this.save_content('pretext');
        });
        return ArticleTag.find(_this.article().id, function(data) {
          var tag, _i, _len;
          _this.article().tags([]);
          for (_i = 0, _len = data.length; _i < _len; _i++) {
            tag = data[_i];
            _this.article().tags.push(ArticleTag(tag));
            $('#tags').val($('#tags').val() + ',' + tag.id);
          }
          return $('#tags').selectize({
            options: all_tags,
            labelField: 'name',
            valueField: 'id',
            searchField: 'name',
            create: true,
            plugins: ['remove_button'],
            onItemAdd: function(value, item) {
              return _this.article().add_tag({
                'id': value
              });
            },
            onItemRemove: function(value) {
              return _this.article().remove_tag({
                'id': value
              });
            },
            onOptionAdd: function(value, data) {
              return _this.article().create_tag(value);
            }
          });
        });
      };
    })(this));
  };

  ArticleView.prototype.save_content = function(type) {
    if (type == null) {
      type = 'content';
    }
    $('.saving-status.saved').hide();
    $('.saving-status.saving').show();
    clearTimeout(window.timeoutEditor);
    return window.timeoutEditor = setTimeout((function(_this) {
      return function() {
        if (type === 'content') {
          _this.article().content(window.editor.serialize().post_content.value);
        } else if (type === 'title') {
          _this.article().title(window.title_editor.serialize().post_title.value);
        } else if (type === 'pretext') {
          _this.article().pretext(window.pretext_editor.serialize().post_pretext.value);
        }
        $('.saving-status.saving').hide();
        return $('.saving-status.saved').show();
      };
    })(this), 500);
  };

  ArticleView.prototype.add_image = function(e, callback) {
    $.fancybox.open({
      href: '#asset-selector',
      topRatio: 0.5,
      autoSize: false,
      width: '95%',
      height: '95%'
    });
    return window.asset_sub = assetsgrid.asset.subscribe((function(_this) {
      return function(asset) {
        e = e.parent().parent().parent();
        $('.mediumInsert-buttonsOptions', e).remove();
        $(".mediumInsert-buttonsExpand", e).remove();
        e.html('<figure class="article-image" draggable="true" contenteditable="false"><a href="' + asset.url + '" class="fancybox"><img src="' + asset.large_url + '" data-original="' + asset.url + '" data-height="' + asset.height + '" data-ratio="' + asset.ratio + '" alt="" /></a> <figcaption contenteditable="true" data-placeholder="(optional) Enter image caption here"></figcaption> </figure>');
        $('figure', e).unwrap().unwrap();
        $.fancybox.close();
        window.asset_sub.dispose();
        _this.save_content();
        return callback();
      };
    })(this));
  };

  ArticleView.prototype.add_video = function(e, callback) {
    var url, vd_rg, vid_id, yt_rg;
    url = e.val();
    yt_rg = /youtube.com/;
    vd_rg = /watch\?v=(\w+)/;
    if (url.match(yt_rg) == null) {
      return;
    }
    if (url.match(vd_rg) == null) {
      return;
    }
    vid_id = url.match(vd_rg)[1];
    e = e.parent().parent().parent().parent().parent();
    $('.mediumInsert-action', e).remove();
    e.html('<figure class="article-image video-preview" draggable="true" contenteditable="false"> <iframe width="1400" height="520" src="//www.youtube-nocookie.com/embed/' + vid_id + '?controls=0&showinfo=0" frameborder="0" allowfullscreen></iframe> </figure>');
    $('figure', e).unwrap().unwrap();
    return callback();
  };

  ArticleView.prototype.set_cover = function() {
    $.fancybox.open({
      href: '#asset-selector',
      topRatio: 0.5,
      autoSize: false,
      width: '95%',
      height: '95%'
    });
    return window.asset_sub = assetsgrid.asset.subscribe((function(_this) {
      return function(asset) {
        return _this.article().set_cover(asset, function() {
          _this.article().asset(Asset(asset));
          _this.article().asset_id = asset.id;
          $.fancybox.close();
          return window.asset_sub.dispose();
        });
      };
    })(this));
  };

  ArticleView.prototype.remove_cover = function() {
    return this.article().unset_cover((function(_this) {
      return function() {
        _this.article().asset(null);
        return _this.article().asset_id = 0;
      };
    })(this));
  };

  ArticleView.prototype.show_title = function() {
    return this.article().option_display_title(true);
  };

  ArticleView.prototype.hide_title = function() {
    return this.article().option_display_title(false);
  };

  ArticleView.prototype.fix_title = function() {
    return this.article().option_fix_title(true);
  };

  ArticleView.prototype.unfix_title = function() {
    return this.article().option_fix_title(false);
  };

  ArticleView.prototype.publish = function() {
    if (confirm('Are you sure you want to publish this article?')) {
      this.article().active(true);
      return setTimeout(((function(_this) {
        return function() {
          return location.href = '/backend/articles';
        };
      })(this)), 500);
    }
  };

  ArticleView.prototype.unpublish = function() {
    if (confirm('Are you sure you want to unpublish this article?')) {
      this.article().active(false);
      return setTimeout(((function(_this) {
        return function() {
          return location.href = '/backend/articles';
        };
      })(this)), 500);
    }
  };

  return ArticleView;

})();

//# sourceMappingURL=articles.js.map
